import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UserTdvModel extends BaseModel {

    constructor() {
        super({ 
                name: "users_tdv",
                tableName: 'users', 
                label: "Danh sách tống đạt viên", 
                display_key: 'fullname', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                display: false
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            code : { 
                name: 'code', 
                type: "String", 
                label: 'Mã nhân viên (Tên đăng nhập)', 
                sortable: false,
                width : 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
            },
            avatar: {
                name: 'avatar', 
                type: "Image",
                label: 'Avatar',
                // inputOptions: { mode: 'multiple' },  
                display: false,
                accessable: "image/*"
            },
            
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Tên nhân viên',
                class: "center",
                width :12, 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            phone : {
                name: 'phone', 
                type: "String", 
                label: 'Số điện thoại', 
                sortable: false,
                width : 10,
                class: "center",
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
            },
            areas: { 
                refs: 'areas {id code} ',
                display: false
            },
            display_areas: {
                name: 'display_areas', 
                label: 'Mã khu vực',
                width : 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_areas = '';
                    if(data.areas !== undefined && data.areas !== null){
                        data.display_areas = data.areas.code;
                    }
                }
            },
            users_state: {
                name: 'users_state', 
                type: "Text",
                label: 'Tỉnh tống đạt',
                class: "center",
                width :12,
                filter: { type: 'input', match: 'contains'}
                // display: false
            },
            users_district: {
                name: 'users_district', 
                type: "Text",
                label: 'Quận TĐV phụ trách',
                width : 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            users_ward: {
                name: 'users_ward', 
                type: "Text",
                label: 'Phường TĐV phụ trách',
                width : 10,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            ref_users_dpv: { 
                refs: 'users_dpv {id fullname}',
                display: false
            },
            display_users_dpv: {
                name: 'display_users_dpv', 
                label: 'ĐPV quản lý',
                width : 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_users_dpv = '';
                    if(data.users_dpv !== undefined && data.users_dpv !== null){
                        data.display_users_dpv = data.users_dpv.fullname;
                    }
                }
            },
            active: {
                name: 'active', 
                type: "Boolean",
                label: 'Trạng thái',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },
            display_active: {
                name: 'display_active', 
                label: 'Trạng thái',
                width : 10,
                class: "center",
                computed: (data) => {
                    data.display_active = '<div style="text-align: center;"><i class="pi pi-times"></i></div>';
                    if(data.active == true){
                        data.display_active = '<div style="text-align: center;"><i class="pi pi-check"></i></div>';
                    }
                }    
            }
        },)
    }

}